import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { MediaUpload } from "@/components/site/MediaUpload";
import { toast } from "sonner";

const inp = "bg-zinc-900 border-white/10 text-white";
function F({ label, hint, children }) { return <div><Label className="text-xs uppercase tracking-wider text-zinc-400">{label}</Label><div className="mt-1">{children}</div>{hint && <p className="mt-1 text-xs text-zinc-500">{hint}</p>}</div>; }

export function SiteSettingsEditor() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/settings").then(({ data }) => setF(data || {})); }, []);
  if (!f) return <Loader2 className="h-8 w-8 animate-spin text-[#DCA846]" />;
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { site_name: f.site_name, logo: f.logo, favicon: f.favicon, seo_title: f.seo_title, seo_description: f.seo_description, social_image: f.social_image });
      toast.success("Site settings saved");
    } catch { toast.error("Save failed"); } finally { setSaving(false); }
  };
  return (
    <div className="max-w-2xl space-y-5 rounded-lg border border-white/10 bg-zinc-900/40 p-5">
      <F label="Site Name"><Input data-testid="site-name" value={f.site_name || ""} onChange={(e) => set("site_name", e.target.value)} className={inp} placeholder="Epic Fade Academy" /></F>
      <MediaUpload label="Logo (leave empty to keep current text logo)" value={f.logo} onChange={(v) => set("logo", v)} kind="image" testid="site-logo-upload" />
      <MediaUpload label="Favicon" value={f.favicon} onChange={(v) => set("favicon", v)} kind="image" testid="site-favicon-upload" />
      <div className="border-t border-white/5 pt-4">
        <p className="mb-3 font-display text-sm uppercase tracking-wide text-[#DCA846]">SEO & Social Sharing</p>
        <div className="space-y-4">
          <F label="SEO Default Title"><Input data-testid="seo-title" value={f.seo_title || ""} onChange={(e) => set("seo_title", e.target.value)} className={inp} placeholder="Epic Fade Academy — Premium Barber Education" /></F>
          <F label="SEO Default Description"><Textarea data-testid="seo-description" rows={2} value={f.seo_description || ""} onChange={(e) => set("seo_description", e.target.value)} className={inp} /></F>
          <MediaUpload label="Social Sharing Image (og:image)" value={f.social_image} onChange={(v) => set("social_image", v)} kind="image" testid="social-image-upload" />
        </div>
      </div>
      <p className="text-xs text-zinc-500">Your current logo/branding is never changed automatically — these apply only when you set them.</p>
      <Button data-testid="save-site-btn" onClick={save} disabled={saving} className="bg-[#DCA846] text-black hover:bg-[#C5963B]">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="mr-1 h-4 w-4" /> Save Site Settings</>}</Button>
    </div>
  );
}
